// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';
import { v1DayPropertiesUpdateSchema } from './v1/dayProperties/updateSchema';
import { v1DayPropertySchema } from './v1/dayPropertySchema';
import { v1ValidationErrorSchema } from './v1/validationErrorSchema';

export const updateDayPropertiesPathParamsSchema = z.object({
  account_id: z.number().int().describe("Account ID"),
});

export const updateDayPropertiesHeaderParamsSchema = z.object({
  Authorization: z.coerce.string().describe("OAuth 2.0 Bearer token"),
});

/**
 * @description Day properties updated successfully
 */
export const updateDayProperties200Schema = z.array(z.lazy(() => v1DayPropertySchema));

/**
 * @description Validation errors
 */
export const updateDayProperties422Schema = z.lazy(() => v1ValidationErrorSchema);

export const updateDayPropertiesMutationRequestSchema = z.lazy(() => v1DayPropertiesUpdateSchema);

export const updateDayPropertiesMutationResponseSchema = z.lazy(() => updateDayProperties200Schema);
